module.exports = {
	"root": "findify-components-search--mobile-sorting",
	"header": "findify-components-search--mobile-sorting__header",
	"body": "findify-components-search--mobile-sorting__body",
	"footer": "findify-components-search--mobile-sorting__footer",
	"title": "findify-components-search--mobile-sorting__title",
	"item": "findify-components-search--mobile-sorting__item"
};